"use client";

import type { FootballTemplateData } from "../football-template";
import { ActivityCourtPreview } from "./activity-court-preview";

type FootballDisplayPreviewProps = {
  data: FootballTemplateData | null;
  participants: {
    id: string;
    displayName: string;
    avatarUrl: string | null;
    username: string | null;
  }[];
};

export function FootballDisplayPreview({
  data,
  participants,
}: FootballDisplayPreviewProps) {
  if (!data) {
    return (
      <ActivityCourtPreview
        activityId="football"
        yourTeam={[]}
        opponentTeam={[]}
      />
    );
  }

  const yourTeam = participants
    .filter((p) => data.positions[p.id] === "your-team")
    .map((p) => ({ ...p, handle: p.username ?? undefined }));
  const opponentTeam = participants
    .filter((p) => data.positions[p.id] === "opponent-team")
    .map((p) => ({ ...p, handle: p.username ?? undefined }));

  const showScore = data.hasScore !== false;
  const yourGoals = data.matchScore.yourGoals;
  const opponentGoals = data.matchScore.opponentGoals;
  const penaltiesWinner = (() => {
    const penalties = data.penalties;
    if (!penalties) return null;
    if (penalties.yourScore === penalties.opponentScore) return null;
    return penalties.yourScore > penalties.opponentScore ? "team1" : "team2";
  })();

  const yourWon =
    yourGoals > opponentGoals ||
    (yourGoals === opponentGoals && penaltiesWinner === "team1");

  return (
    <div>
      <ActivityCourtPreview
        activityId="football"
        data={data}
        yourTeam={yourTeam}
        opponentTeam={opponentTeam}
        yourWon={showScore ? yourWon : undefined}
        linkToProfiles
      />
    </div>
  );
}
